<template lang="pug">
  ul.dropdown
    li.dropdown__item(
      @click="onChooseLang($event, 'RU')"
    )
      .dropdown__link
        .lang(
          :class="{ 'lang_active': lang === 'RU' }"
        )
          .lang__icon
            img(src="@/assets/images/languages/ru.png")
          .lang__text Русский
    li.dropdown__item(
      @click="onChooseLang($event, 'TAT')"
    )
      .dropdown__link
        .lang(
          :class="{ 'lang_active': lang === 'TAT' }"
        )
          .lang__icon
            img(src="@/assets/images/languages/tat.png")
          .lang__text Татарский
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  name: "LangDropdown",
  props: ["onChooseLang"],
  computed: {
    ...mapState(["userData", "lang"]),
  },
  methods: {
    ...mapMutations(["removeToken"]),
    onBodyClick() {
      this.$emit("close");
    },
  },
  created() {
    document.body.addEventListener("click", this.onBodyClick);
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.onBodyClick);
  },
};
</script>
